import { isIOS, isWeb } from './platformHelpers';
import CommonTypes from '../@types/redux/store/CommonTypes';
import { UIManager } from '../native/UIManager';
import { injectedStore } from '../globals/StoreAccess';
import {
  injectedActionSheet,
  injectedAlert,
} from '../globals/ConfigureGlobals';

export type DialogOption = {
  title: any;
  action?: () => void;
};

export const showAlert = (
  title: string,
  message: string,
  yesActionText: any = null,
  yesAction: () => void = () => {},
  noActionText: any = null,
  noAction: () => void = () => {},
  isDestructive: boolean = false
) => {
  if (isWeb()) {
    const dialog = {
      title,
      message,
      yesActionText,
      yesAction,
      noActionText,
      noAction,
      isDestructive,
    };
    injectedStore.dispatch({
      type: CommonTypes.SET_DIALOG,
      payload: { dialog },
    });
  } else if (isIOS()) {
    const options = [];

    if (noActionText && noActionText !== '') {
      options.push(noActionText);
    }

    if (yesActionText && yesActionText !== '') {
      options.push(yesActionText);
    }

    const defaultOptions = {
      title,
      message,
      options,
      cancelButtonIndex: 0,
    };
    const destructiveOptions = { ...defaultOptions, destructiveButtonIndex: 1 };
    injectedActionSheet?.showActionSheetWithOptions(
      isDestructive ? destructiveOptions : defaultOptions,
      (buttonIndex: number) => {
        if (buttonIndex === 1) {
          yesAction();
        }

        if (buttonIndex === 0) {
          noAction();
        }
      }
    );
  } else {
    const androidTitle = title !== '' ? title : null;
    const androidMessage = message !== '' ? message : null;
    injectedAlert?.alert(
      androidTitle,
      androidMessage,
      [
        {
          text: noActionText || 'Cancel',
          onPress: noAction,
          style: 'cancel',
        },
        {
          text: yesActionText || 'OK',
          onPress: yesAction,
          style: isDestructive ? 'destructive' : 'default',
        },
      ],
      { cancelable: true }
    );
  }
};

export const showAlertWithOptions = (
  title: string,
  message: string,
  options: DialogOption[] = [],
  isDestructive: boolean = false
) => {
  if (isWeb()) {
    const dialog = {
      title,
      message,
      options,
    };
    injectedStore.dispatch({
      type: CommonTypes.SET_DIALOG,
      payload: { dialog },
    });
  } else {
    const optionsTitles = options?.map((option) => option?.title);
    const optionsActions = options?.map((option) => option?.action);

    if (isIOS()) {
      const defaultOptions = {
        title,
        message,
        options: optionsTitles,
        cancelButtonIndex: 0,
      };
      const destructiveOptions = {
        ...defaultOptions,
        destructiveButtonIndex: 1,
      };
      setTimeout(
        () =>
          injectedActionSheet?.showActionSheetWithOptions(
            isDestructive ? destructiveOptions : defaultOptions,
            (buttonIndex: number) => {
              if (typeof optionsActions[buttonIndex] === 'function') {
                // @ts-ignore
                optionsActions[buttonIndex]();
              }
            }
          ),
        50
      );
    } else {
      setTimeout(() => {
        UIManager.showListAlert(title, optionsTitles, (response) => {
          if (response.buttonIndex) {
            const selectedIndex = parseInt(response.buttonIndex, 10);

            if (typeof optionsActions[selectedIndex] === 'function') {
              // @ts-ignore
              optionsActions[selectedIndex]();
            }
          }
        });
      }, 50);
    }
  }
};
